// modules
import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import PropTypes from 'prop-types'

// Helper function to get an SVG source for standalone mode
const getSvgSrc = (iconName) => {
  try {
    return require(`src/assets/images/standalone/${iconName}.svg`)
  } catch (error) {
    console.warn(
      `SVG icon "${iconName}" not found in assets/images/standalone/`
    )
    return null
  }
}

const Icon = ({
  className = 'anticon',
  name = '',
  onClick = () => null,
  iconType = 'FontAwesomeIcon',
  ...restProps
}) => {
  // Render standalone SVG icon
  if (iconType === 'standalone') {
    const svgSrc = getSvgSrc(name)

    if (!svgSrc) {
      return null
    }

    return (
      <i
        {...restProps}
        className={classNames({ [className]: className })}
        onClick={onClick}>
        <img src={svgSrc} alt={name} {...restProps} />
      </i>
    )
  }

  // Render FontAwesome icon (default)
  return (
    <i
      {...restProps}
      className={classNames({ [className]: className })}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={name} {...restProps} />
    </i>
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string.isRequired,
    PropTypes.shape({
      iconName: PropTypes.string.isRequired,
      prefix: PropTypes.string.isRequired
    }).isRequired
  ]).isRequired,
  iconType: PropTypes.oneOf(['standalone', 'FontAwesomeIcon'])
}

export default Icon
